<template>
  <div class="jd-inbond-page">
    <div class="toolbar">
      <el-input
        v-model="filters.keyword"
        class="toolbar-item keyword-input"
        clearable
        placeholder="关键字"
        prefix-icon="el-icon-search"
      />
      <el-input
        v-model="filters.serialName"
        class="toolbar-item"
        clearable
        placeholder="物料名称"
      />
      <el-input
        v-model="filters.paperNumber"
        class="toolbar-item"
        clearable
        placeholder="图纸号"
      />
      <el-input
        v-model="filters.factory"
        class="toolbar-item"
        clearable
        placeholder="厂商"
      />
      <el-input
        v-model="filters.jdOrderCode"
        class="toolbar-item"
        clearable
        placeholder="金蝶订单号"
      />
      <el-select
        v-model="filters.inbondStatus"
        class="toolbar-item status-select"
        placeholder="入库单状态"
      >
        <el-option label="全部状态" value="" />
        <el-option label="未回写入库单" value="empty" />
        <el-option label="已回写入库单" value="filled" />
      </el-select>
      <el-date-picker
        v-model="filters.endTimeRange"
        class="toolbar-item date-range"
        type="daterange"
        unlink-panels
        value-format="timestamp"
        range-separator="至"
        start-placeholder="入库开始时间"
        end-placeholder="入库结束时间"
      />
      <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
      <el-button icon="el-icon-refresh-left" @click="resetFilters">重置</el-button>
      <el-button icon="el-icon-refresh" @click="fetchData">刷新</el-button>
    </div>

    <el-table
      v-loading="loading"
      :data="pagedData"
      border
      stripe
      row-key="id"
      empty-text="暂无入库数据"
      class="inbond-table"
    >
      <el-table-column prop="serialName" label="物料名称" min-width="160" show-overflow-tooltip />
      <el-table-column prop="paperNumber" label="图纸号" min-width="140" show-overflow-tooltip />
      <el-table-column prop="factory" label="厂商" min-width="130" show-overflow-tooltip />
<!--      <el-table-column prop="createUserId" label="入库人ID" width="100" align="center" />-->
      <el-table-column prop="totalQty" label="入库总数" width="100" align="right" />
      <el-table-column prop="productQty" label="成品数量" width="100" align="right" />
      <el-table-column prop="scraptQty" label="产生废品数量" width="120" align="right" />
      <el-table-column prop="redoQty" label="废品回用数量" width="120" align="right" />
      <el-table-column prop="inbondScraptQty" label="直接入库废品" width="120" align="right" />
      <el-table-column label="加工开始时间" min-width="160">
        <template slot-scope="scope">
          {{ formatTime(scope.row.startTime) }}
        </template>
      </el-table-column>
      <el-table-column label="入库时间" min-width="160">
        <template slot-scope="scope">
          {{ formatTime(scope.row.endTime) }}
        </template>
      </el-table-column>
      <el-table-column prop="jdOrderLineId" label="是否同步金蝶订单行ID" min-width="150" show-overflow-tooltip >
        <template slot-scope="scope">
          {{scope.row.jdOrderLineId ? "是" : "否"}}
        </template>
      </el-table-column>
<!--      <el-table-column prop="jdOrderId" label="金蝶订单ID" min-width="150" show-overflow-tooltip />-->
      <el-table-column prop="inbondCode" label="是否同步" min-width="160" show-overflow-tooltip >
        <template slot-scope="scope">
          {{scope.row.inbondCode ? "是" : "否"}}
        </template>
      </el-table-column>
      <el-table-column prop="jdMsg" label="返回信息" min-width="220" show-overflow-tooltip />
      <el-table-column label="操作" width="110" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="danger"
            size="mini"
            :disabled="!canClearInbound(scope.row)"
            @click="handleClearInbound(scope.row)"
          >
            清除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-row">
      <el-pagination
        :current-page="currentPage"
        :page-size="pageSize"
        :page-sizes="[10, 20, 50, 100]"
        :total="filteredData.length"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";

export default {
  name: "JdInbond",
  data() {
    return {
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      filters: {
        keyword: "",
        serialName: "",
        paperNumber: "",
        factory: "",
        jdOrderCode: "",
        inbondStatus: "",
        endTimeRange: []
      },
      searchableFields: [
        "id",
        "serialId",
        "serialName",
        "paperNumber",
        "createUserId",
        "totalQty",
        "productQty",
        "scraptQty",
        "redoQty",
        "inbondScraptQty",
        "factory",
        "jdOrderLineId",
        "jdOrderId",
        "jdOrderCode",
        "startTime",
        "endTime",
        "inbondCode",
        "jdMsg"
      ]
    }
  },
  computed: {
    filteredData() {
      return this.tableData.filter(row => {
        return this.matchKeyword(row)
          && this.matchText(row.serialName, this.filters.serialName)
          && this.matchText(row.paperNumber, this.filters.paperNumber)
          && this.matchText(row.factory, this.filters.factory)
          && this.matchText(row.jdOrderCode, this.filters.jdOrderCode)
          && this.matchInbondStatus(row)
          && this.matchEndTime(row)
      })
    },
    pagedData() {
      const start = (this.currentPage - 1) * this.pageSize
      return this.filteredData.slice(start, start + this.pageSize)
    }
  },
  watch: {
    filters: {
      handler() {
        this.currentPage = 1
      },
      deep: true
    },
    filteredData() {
      this.fixCurrentPage()
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      this.loading = true
      try {
        const res = await request.get("/syn/inbond/findAll")
        if (res.code && res.code.toString() === "200") {
          this.tableData = res.data?.sort((a, b) => {
            return b.id - a.id
          }) || []
          this.currentPage = 1
        } else {
          this.$notify.error({
            title: "错误",
            message: `${res.code}:${res.msg}`
          })
        }
      } catch (error) {
        console.error("查询入库信息失败:", error)
        this.$message.error("查询入库信息失败")
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      this.currentPage = 1
    },
    resetFilters() {
      this.filters = {
        keyword: "",
        serialName: "",
        paperNumber: "",
        factory: "",
        jdOrderCode: "",
        inbondStatus: "",
        endTimeRange: []
      }
      this.currentPage = 1
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.fixCurrentPage()
    },
    canClearInbound(row) {
      return !!(row && (row.inbondCode || row.jdMsg))
    },
    async handleClearInbound(row) {
      if (!row || !row.id) {
        this.$message.error("清除失败,未找到入库记录")
        return
      }
      try {
        await this.$confirm("确认清除该记录的入库编号和返回信息吗？", "提示", {
          confirmButtonText: "确认清除",
          cancelButtonText: "取消",
          type: "warning"
        })
      } catch (error) {
        return
      }

      this.loading = true
      try {
        const res = await request.post(`/syn/inbond/clearInboundCode/${row.id}`)
        if (res.code && res.code.toString() === "200") {
          this.$set(row, "inbondCode", null)
          this.$set(row, "jdMsg", null)
          this.$message.success("清除成功")
        } else {
          this.$notify.error({
            title: "错误",
            message: `${res.code}:${res.msg}`
          })
        }
      } catch (error) {
        console.error("清除入库编号和返回信息失败:", error)
        this.$message.error("清除入库编号和返回信息失败")
      } finally {
        this.loading = false
      }
    },
    fixCurrentPage() {
      const pageMax = Math.ceil(this.filteredData.length / this.pageSize)
      this.currentPage = this.currentPage > pageMax ? pageMax : this.currentPage
      this.currentPage = this.currentPage < 1 ? 1 : this.currentPage
    },
    matchKeyword(row) {
      const keyword = this.normalize(this.filters.keyword)
      if (!keyword) {
        return true
      }
      return this.searchableFields.some(field => this.normalize(row[field]).includes(keyword))
    },
    matchText(value, filterValue) {
      const keyword = this.normalize(filterValue)
      if (!keyword) {
        return true
      }
      return this.normalize(value).includes(keyword)
    },
    matchInbondStatus(row) {
      if (!this.filters.inbondStatus) {
        return true
      }
      const isEmpty = row.inbondCode === undefined || row.inbondCode === null || row.inbondCode === ""
      return this.filters.inbondStatus === "empty" ? isEmpty : !isEmpty
    },
    matchEndTime(row) {
      if (!this.filters.endTimeRange || this.filters.endTimeRange.length !== 2) {
        return true
      }
      const value = this.getTime(row.endTime)
      if (!value) {
        return false
      }
      return value >= this.filters.endTimeRange[0] && value <= this.filters.endTimeRange[1]
    },
    normalize(value) {
      if (value === undefined || value === null) {
        return ""
      }
      return value.toString().trim().toLowerCase()
    },
    getTime(value) {
      if (!value) {
        return null
      }
      const time = new Date(value).getTime()
      return Number.isNaN(time) ? null : time
    },
    formatTime(value) {
      const time = this.getTime(value)
      if (!time) {
        return ""
      }
      const date = new Date(time)
      const pad = num => num.toString().padStart(2, "0")
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
    }
  }
}
</script>

<style scoped>
.jd-inbond-page {
  padding: 10px;
}

.toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
  margin-bottom: 12px;
}

.toolbar-item {
  width: 150px;
}

.keyword-input {
  width: 180px;
}

.status-select {
  width: 140px;
}

.date-range {
  width: 300px;
}

.inbond-table {
  width: 100%;
}

.pagination-row {
  margin-top: 12px;
  text-align: right;
}
</style>
